import { render } from "./HeroAuthDashboardHeader.vue?vue&type=template&id=54c77461&scoped=true"
import script from "./HeroAuthDashboardHeader.vue?vue&type=script&lang=js"
export * from "./HeroAuthDashboardHeader.vue?vue&type=script&lang=js"

import "./HeroAuthDashboardHeader.vue?vue&type=style&index=0&id=54c77461&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c77461"]])

export default __exports__